import { DataProvider, Identifier, Record } from "react-admin";

export const REACT_APP_FILES_URL = process.env.REACT_APP_FILES_URL as string;

export const removeFiles = async (dataProvider: DataProvider, ids: number[] | number) => {
    if (typeof ids === "number") {
        ids = [ids];
    }
    if (ids?.length > 0) {
        // On enlève les fichiers
        await dataProvider.getMany<FileUpload>("file", { ids }).then(async ({ data }) => {
            for (const file of data) {
                await tusRemove(file.tusId);
            }
        });
        // On supprimer les fichiers
        await dataProvider.deleteMany("file", { ids });
    }
};

const tusRemove = async (tusId: string): Promise<Response> => {
    return fetch(new Request(`${REACT_APP_FILES_URL}${tusId}`, {
        method: 'DELETE',
        headers: new Headers({
            "Tus-Resumable": "1.0.0"
        })
    }));
};

export interface FileUpload extends Record {
    id: Identifier;
    name: string;
    size: number;
    type: string;
    tusId: string;
    uploadDate: Date;
    extension: string;
}

export const removeFile = (dataProvider: DataProvider, record: FileUpload, notify, removeItemFromRecord) => {
    tusRemove(record.tusId).then((response) => {
        removeItemFromRecord(record.id).then(() => {
            dataProvider.delete("file", { id: record.id, previousData: record }).then(() => {
                notify("resources.file.success");
            }).catch((err) => {
                notify("resources.file.remove", { type: "error", messageArgs: { err } })
            });
        }).catch((err) => {
            notify("resources.file.remove", { type: "error", messageArgs: { err } })
        });
    }
    ).catch((err) => {
        notify("resources.file.remove", { type: "error", messageArgs: { err } })
    });
};


export const openFile = (record: FileUpload) => {
    window.open(`${REACT_APP_FILES_URL}${record.tusId}`)
};